import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { useClientAuth } from "@/context/ClientAuthContext";
import { AuthShell, AuthInput, SubmitButton, usePending, Lock } from "@/components/portal/AuthShell";

export default function PortalLogin() {
  const { client, login } = useClientAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, run] = usePending();

  useEffect(() => { if (client) navigate("/espace-client"); }, [client, navigate]);

  const submit = (e) => {
    e.preventDefault();
    run(async () => {
      try { await login(email, password); toast.success("Bienvenue dans votre Espace client"); }
      catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    });
  };

  return (
    <AuthShell title="Connexion" subtitle="Accédez à vos devis, factures et tickets de support.">
      <form onSubmit={submit} className="space-y-4" data-testid="portal-login-form">
        <AuthInput type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@entreprise.com" data-testid="portal-login-email" />
        <AuthInput icon={Lock} type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mot de passe" data-testid="portal-login-password" />
        <SubmitButton loading={loading} data-testid="portal-login-submit">{loading ? "Connexion…" : "Se connecter"}</SubmitButton>
      </form>
      <p className="mt-6 text-xs text-slate-500 leading-relaxed">Pas encore d'accès ? Votre compte est créé par votre conseiller VISION LOGICIELS. <Link to="/contact" className="text-[#0F2A6B] font-semibold hover:text-[#4CB944]">Contactez-nous</Link>.</p>
    </AuthShell>
  );
}
